import { FacilitiesContainer } from '../../containers/advancedFilters/FacilitiesContainer';
import { IFilter } from '../../types/advancedFilters';

export const facilities: IFilter = {
  component: FacilitiesContainer,
};
